<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Contacts</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_contacts'" /> -->
                <GekkoButton 
                    :text="$gettext('New contact')" 
                    :to="{name: 'AddContact'}"
                    icon="fa-solid fa-plus"
                    class="mr-2"
                />
                <GekkoButton 
                    @click="download"
                    :text="$gettext('Download')" 
                    icon="fa-solid fa-download"
                    class="mr-2"
                    variant="outline-primary"
                />
                <GekkoButton 
                    @click="importContacts"
                    :text="$gettext('Import')" 
                    icon="fa-solid fa-upload"
                    variant="outline-primary"
                />
            </template>
        </TitleBar>
        <div class="content">
            <ContactTable></ContactTable>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { promptDownload } from "@/utils/"

import TitleBar from "@/components/TitleBar";
import ContactTable from "@/components/contacts/ContactTable";
import GekkoButton from "@/components/GekkoButton";
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

import CustomerService from "@/store/services/customer.service.js";

export default {
    name: "Contacts",
    components: { 
        TitleBar, 
        ContactTable, 
        GekkoButton,
        // OnboardingIntroLink 
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId'
        }),
    },
    methods: {
        goToAddContact() {
            this.$router.push({name: 'AddContact'});
        },
        download () {
            const filters = this.$store.getters['filterStore/getFilter'];
            CustomerService.getContactsFileBlob(this.getCompanyId, filters).then(response => {
                promptDownload(response)
            }).catch(error => console.error('Error downloading Contacts:', error));
        },
        importContacts() {
            window.location.href = window.Urls['accounts_import_data_settings']();
        }
    }
}
</script>

<style scoped>

</style>
